import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ordinal'
})
export class OrdinalNumberPipe implements PipeTransform {
   transform(value: number): string {
        if (isNaN(value) || value === null) {
          return '';
        }

        const s = ['th', 'st', 'nd', 'rd'];
        const v = value % 100;
        return value + (s[(v - 20) % 10] || s[v] || s[0]);
      }
}